/**
 * HeaderOrdersTable Component - Created by miguelcanobbio on 16/07/18.
 */
import * as React from 'react'
import {
  Container,
  Icon,
  IconsContainer,
  Header,
  StyledSpin
} from './styledComponents'
import { sorts } from '../../../types/common'
import { GRAY, GRAY_DARK, WHITE } from '../../../theme/colors'

interface Props {
  label: string | React.ReactNode
  sort?: sorts
  id: string
  justifyContent?: string
  interactiveHeaders?: boolean
  loading?: boolean
  onSortClick?: (id: string, sort: sorts) => void
}

const colors = {
  asc: { upColor: GRAY_DARK, downColor: WHITE },
  desc: { upColor: WHITE, downColor: GRAY_DARK },
  none: { upColor: GRAY, downColor: GRAY }
}

const HeaderOrdersTable = ({
  id,
  label,
  sort,
  onSortClick,
  justifyContent,
  interactiveHeaders = false,
  loading
}: Props) => {
  if (!interactiveHeaders) {
    const textAlign = justifyContent === 'flex-end' ? 'right' : (justifyContent === 'center' ? 'center' : 'left')
    return <Header {...{ textAlign }}>{label}</Header>
  }

  const handleOnClick = () => {
    const sortToApply = sort === 'asc' ? 'desc' : 'asc'
    if (onSortClick) {
      onSortClick(id, sortToApply)
    }
  }
  const { upColor, downColor } = colors[sort]
  return (
    <Header>
      <Container {...{ justifyContent }}>
        {label}
        {id ? (
          <IconsContainer onClick={handleOnClick}>
            <Icon type="up" color={upColor} />
            <Icon type="down" color={downColor} />
          </IconsContainer>
        ) : null}
        {loading && <StyledSpin size={'small'} />}
      </Container>
    </Header>
  )
}

export default HeaderOrdersTable



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TestPrintList/HeaderOrdersTable/index.tsx